import { Component } from '@angular/core';
import { TranslatePipe } from "@ngx-translate/core";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-privacy-notice',
  standalone: true,
  imports: [TranslatePipe, CommonModule],
  templateUrl: './privacy-notice.component.html',
  styleUrl: './privacy-notice.component.scss'
})
export class PrivacyNoticeComponent {

}
